exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dataTable tr:nth-child(even) td {\r\n    background-color: rgba(0,0,0,0.03);\r\n}\r\ntable.dataTable thead th, table.dataTable thead td {\r\n    border-bottom: 1px solid #cccccc;\r\n    border-radius: 0;\r\n}\r\ntable.dataTable.no-footer {\r\n    border-bottom: 1px solid #cccccc;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Atlassian/bamboo-home/1/7766019/ESDE-EN172-JOB1/ng5/src/app/ui-elements/ui-elements.component.css
// module id = ../../../../../src/app/ui-elements/ui-elements.component.css
// module chunks = main